<template>
    <el-dialog
        title='查看考核明细'
        v-model="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <div >
            <div style="margin-bottom: 15px;font-size: 16px;">姓名：{{ tongjiObj.name }}</div>
            <div  style="margin-bottom: 15px;font-size: 16px;">考核时间：{{ tongjiObj.created }}</div>
            <div  style="margin-bottom: 15px;font-size: 16px;">统计得分：{{ tongjiObj.score }}</div>
        </div>
        <el-form >
         <div class="fuzzy-matching-bottom">
           <el-row class="list">
             <el-table
                :border="true"
                :header-cell-style="{background:'#EDF6FF',color:'#000',}"
                style="width: 100%"
                :data="tableData"
             >
              <el-table-column
                prop="checkTaskName"
                label="任务名称"
                >
              </el-table-column>
              <el-table-column
                prop="checkItemName"
                label="考核项名称"
                >
              </el-table-column>
              <el-table-column
                prop="created"
                label="时间"
                >
              </el-table-column>
              <el-table-column
                prop="score"
                label="分数"
                >
              </el-table-column>
              <el-table-column
                prop="comment"
                label="评语"
                >
              </el-table-column>

              <!-- <el-table-column
                label="操作"
                >
                <template #default="scope">
                  <el-button class="shanchuBtn" type="text" size="small" @click="deleteClick(scope.row)" >删除</el-button>

                </template>
              </el-table-column> -->

            </el-table>
          </el-row>

    </div>
    </el-form>
        
    </el-dialog>
</template>
<script>
import { recordTaskList} from '@/assets/api/deyu.js'
// import { ElMessage } from 'element-plus'

export default {
    components: {
    },
    props: ['tongjiObj','checkUser'],
    data() {

        return {
            dialogVisible: true,
            title:'',
            form:{
                imei:'',
            },
            cardid:"",
            tableData:[],
            titele:""
          
        }

    },
    created(){
       
    },
    mounted(){
        console.log(this.tongjiObj,this.checkUser,'信息');
        
        this.deviceClick()


    },
    methods:{
        handleClose() {
                this.$emit('back')
        },
        deviceClick(){
            const params  = {
                checkTaskId:this.tongjiObj.checkTaskId,
                checkUserName:this.tongjiObj.name,
                checkUserType:this.checkUser,
                page:'1',
                pageSize:'999',
            }
            recordTaskList(params).then((res)=> {
            console.log(res,'查询');
            this.tableData = res.data.data.list

        }).catch((err)=> {
            console.log(err,'查询');
            this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
          })
      }
    }
    }




</script>
<style  scoped lang="scss">
    :deep() {
        .el-input--small .el-input__wrapper{
            height: 35px;
            line-height: 35px;
            text-align: center;
            width: 280px;
        }
        .el-input__inner{
            // width: 10px !important;
        }
        .buttom-box {
        // text-align: center;
        // margin-left: 180px;


    }
    .el-table--small .cell{
          text-align: center;
        }
    .el-form-item--small{
        width: 70% !important;
    }
    }
</style>